import type { HttpClient } from './http.js';

export interface TimerPreset {
  id: string;
  name: string;
  focus_duration: number;
  short_break_duration: number;
  long_break_duration: number;
  cycle_count: number;
}

export interface PresetInput {
  name: string;
  focus_duration: number;
  short_break_duration: number;
  long_break_duration: number;
  cycle_count: number;
}

export function createPresetsApi(http: HttpClient) {
  return {
    list(): Promise<{ presets: TimerPreset[] }> {
      return http.json('/api/presets');
    },

    create(preset: PresetInput): Promise<{ preset: TimerPreset }> {
      return http.json('/api/presets', {
        method: 'POST',
        body: JSON.stringify(preset),
      });
    },

    remove(id: string): Promise<{ success: boolean }> {
      return http.json(`/api/presets/${encodeURIComponent(id)}`, {
        method: 'DELETE',
      });
    },
  };
}
